// Firebase 설정 파일
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// Firebase 설정 정보
const firebaseConfig = {
  apiKey: "AIzaSyCssaHtT5FpW3LmtNGgrm80bnXuTddFDYI",
  authDomain: "ksmartech-meetings.firebaseapp.com",
  projectId: "ksmartech-meetings",
  storageBucket: "ksmartech-meetings.firebasestorage.app",
  messagingSenderId: "234403216626",
  appId: "1:234403216626:web:4eb5b6f9c6cc480feaa46b",
  measurementId: "G-2E9FCHF0YK"
};

// Firebase 초기화
const app = initializeApp(firebaseConfig);

// Analytics 인스턴스 생성 (브라우저 환경에서만 동작)
let analytics: any = null;

// 브라우저 환경에서만 analytics 초기화
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Firebase Analytics 이벤트 로깅 함수
export const logFirebaseEvent = (eventName: string, eventParams?: Record<string, any>) => {
  try {
    if (!analytics) {
      // 개발 환경에서는 로그만 출력
      if (process.env.NODE_ENV === 'development') {
        console.log(`[Firebase Analytics] Event: ${eventName}`, eventParams);
      }
      return;
    }
    
    // 이벤트 이름 검증
    if (!eventName || typeof eventName !== 'string') {
      console.error('[Firebase Analytics] Invalid event name:', eventName);
      return;
    }
    
    // 이벤트 파라미터 검증
    if (eventParams && typeof eventParams !== 'object') {
      console.error('[Firebase Analytics] Invalid event parameters:', eventParams);
      return;
    }
    
    // Firebase Analytics로 이벤트 전송
    logEvent(analytics, eventName, eventParams);
    
    // 개발 환경에서 로그 출력
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Firebase Analytics] Event sent: ${eventName}`, eventParams);
    }
  } catch (error) {
    // 에러 발생 시 애플리케이션 중단 방지
    console.error('[Firebase Analytics] Error sending event:', error);
  }
};

export { app, analytics };

const firebaseService = {
  app,
  analytics,
  logFirebaseEvent
};

export default firebaseService;
